import React from 'react';

import * as S from './styles';

const year = new Date().getFullYear();

const Footer = () => (
  <S.FooterContainer>
    <S.FooterText>
      Powered by{' '}
      <S.FeaturedText href="http://semantix.com.br/" target="_blank">
        Semantix{' '}
      </S.FeaturedText>
      | © {year}
    </S.FooterText>
  </S.FooterContainer>
);

export default Footer;
